{
  "states": {
    "loading": "در حال بارگذاری...",
    "unavailable": "--"
  },
  "button": {
    "defaultCity": "سان‌فرانسیسکو"
  },
  "conditions": {
    "Clear": "صاف",
    "Clouds": "ابری",
    "Rain": "باران",
    "Drizzle": "نم‌نم باران",
    "Thunderstorm": "رعد و برق",
    "Snow": "برف",
    "Mist": "مه رقیق",
    "Smoke": "دود",
    "Haze": "غبار",
    "Dust": "گرد و غبار",
    "Fog": "مه",
    "Sand": "شن",
    "Ash": "خاکستر",
    "Squall": "تندباد",
    "Tornado": "گردباد"
  },
  "modal": {
    "defaultTitle": "آب‌وهوا",
    "subtitle": "شرایط کنونی",
    "showFahrenheit_aria": "نمایش فارنهایت",
    "showCelsius_aria": "نمایش سلسیوس",
    "switchToCelsius_title": "تغییر به °C",
    "switchToFahrenheit_title": "تغییر به °F",
    "feelsLike": "احساس می‌شود {{temp}}°{{unit}}",
    "humidityWind": "رطوبت {{humidity}}٪ · باد {{wind}}",
    "windSpeed": "{{speed}} مایل بر ساعت",
    "hourlyNow": "اکنون",
    "hourlyOffset": "{{hours}} ساعت",
    "hourlyStrip_aria": "دمای ساعتی",
    "hourlyLocked": "پیش‌بینی ساعتی یک ویژگی پرو است.",
    "statsLocked": "جزئیات آب‌وهوا یک ویژگی پرو است.",
    "stats": {
      "sunrise": "طلوع آفتاب",
      "sunset": "غروب آفتاب",
      "feels": "احساس",
      "humidity": "رطوبت",
      "wind": "باد",
      "rain": "باران"
    },
    "rainInches": "{{value}} اینچ",
    "forecastTitle": "پیش‌بینی ۵ روزه",
    "forecastLoading": "در حال بارگذاری پیش‌بینی…",
    "forecastUnavailable": "پیش‌بینی در دسترس نیست",
    "forecastLocked": "پیش‌بینی ۵ روزه یک ویژگی پرو است.",
    "forecastRow_aria": "پیش‌بینی پنج روزه",
    "proHeadline": "پیش‌بینی کامل بخشی از Pro است.",
    "proFeatures": "ساعتی · جزئیات شرایط · چشم‌انداز ۵ روزه."
  }
}
